<mdb-badge
  [pill]="true"
  [warning]="transportOrder.getBadgeStatus()?.code === LIST_DELIVERY_STATUS.PROBLEM.code"
  [info]="transportOrder.getBadgeStatus()?.code === LIST_DELIVERY_STATUS.INTRAVEL.code || transportOrder.getBadgeStatus()?.code === LIST_DELIVERY_STATUS.INITIAL.code"
  [success]="transportOrder.getBadgeStatus()?.code === LIST_DELIVERY_STATUS.DELIVERED.code"
  [danger]="transportOrder.getBadgeStatus()?.code === LIST_DELIVERY_STATUS.CANCELED.code"
>
  <span [jhiTranslate]="transportOrder.getBadgeStatus()?.keyLabel"></span>
</mdb-badge>
